export default __webpack_public_path__ + "static/gaziantep-fk-logo-840011a5580fd7b7afe892902517b115.png";